module.exports = __webpack_public_path__ + "img/qflow.36018433.png";